__webpack_require__.p = "/reports-dashboard-templates-adding-board-flow/referrals-hub/";